import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";

import { FireDataService } from '../fire-data.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  menu: Array<any>;
  itemMenu: Object;

  constructor(private fds: FireDataService, private router: Router, 
              private route: ActivatedRoute, private location: Location) { 

    //this.isLogged();
    this.menu = [];
    this.itemMenu = {path: "/weekly", par: "", title: "Orario" , text: "Consulta orario: generale per giorno, degli insegnanti, delle classi e delle aule"};
    this.menu.push(this.itemMenu);
    this.itemMenu = {path: "/case-list", par: "", title: "Eventi" , text: "Gestisci gli eventi giornalieri di Assenza, Permesso, Uscita classe, ..."};
    this.menu.push(this.itemMenu);
    this.itemMenu = {path: "/teacher-lack", par: "", title: "Assenze e Sostituzioni" , 
    text: "Dashboard giornaliero assenze, con la possibilità di registrare sostituzioni, E/U anticipate della classe, ..."};
    this.menu.push(this.itemMenu);
    this.itemMenu = {path: "/report/tl", par: "", title: "Report Assenze" , text: "Riepilogo mensile assenze e copertura con Sostituzioni"};
    this.menu.push(this.itemMenu);
    this.itemMenu = {path: "/report/ev", par: "", title: "Report Eventi" , text: "Riepilogo mensile eventi e informazioni correlate"};
    this.menu.push(this.itemMenu);
  }

  ngOnInit() {

  }

  private isLogged() {
    this.fds.user.subscribe(res => {
      if (res) {
        return
      }
      if (!res) {
        this.router.navigate(["/login"]);
      }
    });
  }

}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/home/home.component.ts